/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

/**
 * @nullable
 */
export type CampaignUserReviewStatus = typeof CampaignUserReviewStatus[keyof typeof CampaignUserReviewStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignUserReviewStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;
